import React from "react";
import { clsx } from "clsx";

//Classes: primary-cta, nav-button (add nav-button--next for next button, prev is default), add-button.

const Button = React.forwardRef(
    (
        {
            children,
            iconRight,
            iconLeft,
            className,
            primary,
            secondary,
            onClickCallback,
            ...props
        },
        ref
    ) => {
        const classes = clsx(className, {
            "primary-cta": primary,
            "nav-button": secondary,
        });

        const handleClick = (e) => {
            e.preventDefault();
            if (onClickCallback) {
                onClickCallback(e);
            }
        };

        return (
            <button
                ref={ref}
                className={classes}
                onClick={handleClick}
                {...props}
            >
                {iconLeft && (
                    <i
                        aria-hidden
                        className={clsx(
                            iconLeft,
                            "button__icon button__icon--left"
                        )}
                    />
                )}
                <span>{children}</span>
                {iconRight && (
                    <i
                        aria-hidden
                        className={clsx(
                            iconRight,
                            "button__icon button__icon--right"
                        )}
                    />
                )}
            </button>
        );
    }
);

export default Button;
